module.exports = __webpack_public_path__ + "img/safety2.96abf23f.png";